import { createFileRoute } from '@tanstack/react-router'
import { IssuePage } from '../../../components/IssuePage'

export const Route = createFileRoute('/$org/issues/$uid')({
  component: IssueDetail,
})

function IssueDetail() {
  return <IssuePage />
}
